module.exports = __webpack_public_path__ + "img/page15.2b718bf6.jpg";